if (!customElements.get('wbc-product-views')) {
    customElements.define('wbc-product-views', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.frames = Array.from(this.querySelectorAll('[data-product-frame]'));
        this.buttons = Array.from(this.querySelectorAll('.wbc-editorial-product__view-controls button'));
        if (this.frames.length !== this.buttons.length || this.frames.length < 2) return;
        this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index, true), {signal:this.controller.signal}));
        this.select(0);
        this.setAttribute('data-enhanced', '');
      }
      select(index, requested = false) {
        this.frames.forEach((frame, i) => { frame.hidden = i !== index; });
        this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        const image = this.frames[index].querySelector('img');
        if (image && requested) image.loading = 'eager';
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
